export const INPUT_CONTROLS = {
    NAME: 'name',
    EMAIL: 'email',
    ADDRESS: 'address',
    PHONE: 'phone',
    DATE: 'date',
    CUSTOM: 'custom',
    ADDITIONAL_GUESTS: 'additionalGuests',
    COMMENT: 'comment',
};
export var INPUT_NAMES;
(function (INPUT_NAMES) {
    INPUT_NAMES["NAME"] = "name";
    INPUT_NAMES["EMAIL"] = "email";
    INPUT_NAMES["FIRST_NAME"] = "firstName";
    INPUT_NAMES["LAST_NAME"] = "lastName";
    INPUT_NAMES["GUEST_NAMES"] = "guestNames";
    INPUT_NAMES["ADDITIONAL_GUESTS"] = "additionalGuests";
})(INPUT_NAMES || (INPUT_NAMES = {}));
